import { render, staticRenderFns } from "./VideoFilter.vue?vue&type=template&id=1349936e&"
import script from "./VideoFilter.vue?vue&type=script&lang=js&"
export * from "./VideoFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports